import React, { Component, createRef } from "react";
import { Form, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

class HeadingImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageUrl: props.extras?.headingImage
                ? `${props.imgBase}${props.extras['headingImage']}`
                : null,
            uploading: false,
        };
        this.imgInputRef = createRef();
    }

    onChangeFile = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        this.setState({ uploading: true });

        try {
            const formData = new FormData();
            formData.append("file", file);

            const res = await fetch("/api/upload", {
                method: "POST",
                body: formData,
            });

            if (!res.ok) {
                throw new Error(`Upload failed with status ${res.status}`);
            }

            const data = await res.json();
            // Assuming backend returns { url: "/uploads/image.jpg" }
            const fullUrl = data.url.startsWith("http")
                ? data.url
                : `${this.props.imgBase}${data.url}`;

            this.setState({ imageUrl: fullUrl });
        } catch (error) {
            console.error("Image upload failed:", error);
            alert("Image upload failed. Please try again.");
        } finally {
            this.setState({ uploading: false });
        }
    };

    handleImageClick = () => {
        if (this.imgInputRef.current) {
            this.imgInputRef.current.click();
        }
    };

    render() {
        const { currentFields, defImg } = this.props;
        const { imageUrl, uploading } = this.state;

        if (!currentFields?.includes('headingImage')) {
            return null;
        }

        return (
            <Form.Group style={{ position: "relative" }}>
                <Form.Control
                    name="image"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={this.imgInputRef}
                    onChange={this.onChangeFile}
                />

                <Image
                    fluid
                    style={{
                        marginLeft: "25%",
                        width: "50%",
                        height: 150,
                        cursor: "pointer",
                        objectFit: "cover",
                    }}
                    src={imageUrl || defImg}
                    onClick={this.handleImageClick}
                />

                <button
                    type="button"
                    className="btn-success btn btn-circle"
                    style={{ position: "absolute", right: "25%", bottom: 0 }}
                    onClick={this.handleImageClick}
                    disabled={uploading}
                >
                    {uploading ? (
                        <span className="spinner-border spinner-border-sm" role="status" />
                    ) : (
                        <FontAwesomeIcon icon={faPlus} />
                    )}
                </button>
            </Form.Group>
        );
    }
}

export default HeadingImageUploader;
